import { type PageRoute } from '../navigation'

export const TERROS_MCP_PATH = '/integration/mcp'

type TerrosMcpFlag = {
  isEnabled: boolean
  isLoading: boolean
}

export function terrosMcpNavRoute({ isEnabled, isLoading }: TerrosMcpFlag): PageRoute {
  return {
    path: TERROS_MCP_PATH,
    label: 'TerrosMCP',
    icon: 'smart_toy',
    hidden: !isEnabled || isLoading,
  }
}
